module.exports = __webpack_public_path__ + "img/carryOver3.9170eb6a.png";